import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import type { AuthInfo } from '@tww/shared';
import { api, ApiRequestError } from '../api/client';
import { useAuth } from '../auth/AuthProvider';
import logo from '../assets/tww-logo.svg';
import { TextInput } from '../ui/fields';

export function LoginPage() {
  const [sp] = useSearchParams();
  const next = sp.get('next') && sp.get('next')!.startsWith('/') ? sp.get('next')! : '/';
  const info = useQuery({ queryKey: ['auth-info'], queryFn: () => api.get<AuthInfo>('/auth/info') });
  const { refresh } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [showLocal, setShowLocal] = useState(false);

  const submit = async () => {
    setBusy(true);
    setErr(null);
    try {
      await api.post('/auth/local', { email, password });
      await refresh();
      window.location.replace(next);
    } catch (e) {
      setErr(e instanceof ApiRequestError ? e.message : 'Anmeldung fehlgeschlagen');
    } finally {
      setBusy(false);
    }
  };
  const localVisible = info.data?.local && (showLocal || !info.data?.entra);
  return (
    <div className="login">
      <div className="card">
        <div className="brand login-logo">
          <img src={logo} alt="Trinkwasserwald e.V." />
        </div>
        <p className="login-lead">Melde dich mit deinem Microsoft-365-Konto von Trinkwasserwald an.</p>
        {info.data?.entra && (
          <a className="btn primary login-btn" href={`/api/v1/auth/login?next=${encodeURIComponent(next)}`}>
            Mit Microsoft anmelden
          </a>
        )}
        {info.data && !info.data.entra && <div className="note info">Die Microsoft-Anmeldung ist noch nicht eingerichtet.</div>}
        {info.data?.local && !localVisible && (
          <button type="button" className="btn link-like login-alt" onClick={() => setShowLocal(true)}>
            Notfall-Login
          </button>
        )}
        {localVisible && (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              submit();
            }}
            className="login-form"
          >
            <TextInput label="E-Mail" value={email} onChange={setEmail} type="email" autoFocus />
            <TextInput label="Passwort" value={password} onChange={setPassword} type="password" />
            {err && <div className="note bad">{err}</div>}
            <button className="btn primary login-btn" type="submit" disabled={busy || !email || !password}>
              Anmelden
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
